import { render, staticRenderFns } from "./veSbzcJzwMaintainShow.vue?vue&type=template&id=2508633f&scoped=true"
import script from "./veSbzcJzwMaintainShow.vue?vue&type=script&lang=js"
export * from "./veSbzcJzwMaintainShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2508633f",
  null
  
)

export default component.exports